import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { Mutation } from 'vuex-class';
let ProductMixin = class ProductMixin extends mixins(AlertMixin, RouterParamsAppMixin) {
    goToProductsPage() {
        this.$router.push({ name: 'ecommerce-products' });
    }
    buildCategoriesParams(categories) {
        const notDeleted = (category) => !category.isDeleted && !!category.uuid;
        return categories.filter(notDeleted).map((category) => {
            return {
                categoryUuid: category.uuid,
                subcategoryUuids: category.subCategoryUuids,
            };
        });
    }
    buildRegionAvailabilityParams(regions) {
        if (!regions) {
            return null;
        }
        const regionNotDeleted = (region) => !region.isDeleted && !!region.uuid;
        const cityNotDeleted = (city) => !city.isDeleted && !!city.baseGlobalId;
        return regions.filter(regionNotDeleted).map((region) => {
            if (region.productCityPriceHikes.filter(cityNotDeleted).length) {
                return {
                    deliveryAreaRegionUuid: region.uuid,
                    productCityPriceHikes: region.productCityPriceHikes
                        .filter(cityNotDeleted)
                        .map((city) => {
                        return {
                            deliveryAreaCity: city.baseGlobalId,
                            price: city.price,
                        };
                    }),
                };
            }
            return {
                deliveryAreaRegionUuid: region.uuid,
            };
        });
    }
};
__decorate([
    Mutation('requestOnFlight')
], ProductMixin.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], ProductMixin.prototype, "requestDone", void 0);
__decorate([
    Mutation('uploadingOnProgress')
], ProductMixin.prototype, "uploadingOnProgress", void 0);
__decorate([
    Mutation('uploadingDone')
], ProductMixin.prototype, "uploadingDone", void 0);
ProductMixin = __decorate([
    Component
], ProductMixin);
export default ProductMixin;
